var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRequestSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    fill: "#1CA7D1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33325 11.0415V6.979C8.33325 6.76352 8.41885 6.55685 8.57123 6.40448C8.7236 6.25211 8.93026 6.1665 9.14575 6.1665C9.36124 6.1665 9.5679 6.25211 9.72028 6.40448C9.87265 6.55685 9.95825 6.76352 9.95825 6.979V10.4998",
    stroke: "white",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.95825 6.97933V5.896C9.95825 5.7893 9.97927 5.68364 10.0201 5.58507C10.0609 5.48649 10.1208 5.39692 10.1962 5.32147C10.2717 5.24602 10.3612 5.18618 10.4598 5.14534C10.5584 5.10451 10.6641 5.0835 10.7708 5.0835C10.8775 5.0835 10.9831 5.10451 11.0817 5.14534C11.1803 5.18618 11.2698 5.24602 11.3453 5.32147C11.4207 5.39692 11.4806 5.48649 11.5214 5.58507C11.5622 5.68364 11.5833 5.7893 11.5833 5.896V10.5002",
    stroke: "white",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5833 6.979C11.5833 6.76352 11.6689 6.55685 11.8212 6.40448C11.9736 6.25211 12.1803 6.1665 12.3958 6.1665C12.6112 6.1665 12.8179 6.25211 12.9703 6.40448C13.1226 6.55685 13.2083 6.76352 13.2083 6.979V10.4998",
    stroke: "white",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2084 8.0625C13.2084 7.84701 13.294 7.64035 13.4464 7.48798C13.5988 7.3356 13.8054 7.25 14.0209 7.25C14.2364 7.25 14.4431 7.3356 14.5955 7.48798C14.7478 7.64035 14.8334 7.84701 14.8334 8.0625V12.6667C14.8334 13.5286 14.491 14.3553 13.8815 14.9648C13.272 15.5743 12.4454 15.9167 11.5834 15.9167H10.5001H10.6128C10.0745 15.9168 9.5447 15.7832 9.07085 15.5279C8.597 15.2726 8.19396 14.9037 7.89793 14.4542L7.79177 14.2917C7.62277 14.0322 7.02964 12.9982 6.01185 11.189C5.90809 11.0046 5.88038 10.787 5.9346 10.5824C5.98882 10.3779 6.1207 10.2026 6.30218 10.0938C6.49549 9.97776 6.72201 9.92969 6.94577 9.95717C7.16952 9.98465 7.37768 10.0861 7.53718 10.2454L8.33343 11.0417",
    stroke: "white",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestSearch);
export default __webpack_public_path__ + "static/media/request-search.1aad2ac2fe6079acf9c29a2edc398e8b.svg";
export { ForwardRef as ReactComponent };